export default __webpack_public_path__ + "static/media/hero-image-1.33f10ca8.png";